import { error } from '../../logging';
import { ViewNotificationDataType } from './types';

type ViewFilterFn = (filterToBeViewedData: ViewNotificationDataType) => void;

type ViewNotifications = {
  domainName: string;
  viewFilterFunction: ViewFilterFn;
};
class ViewNotificationsRegister {
  private static instance: ViewNotificationsRegister;

  private registry: Record<string, ViewNotifications> = {};

  private constructor() {}

  public register(type: ViewNotifications): void {
    this.registry[type.domainName] = type;
  }

  public getViewFilterFunction(domain: string): (filterToBeViewedData: ViewNotificationDataType) => void {
    const viewNotifications = this.registry[domain];
    if (!viewNotifications) {
      error(new Error(`ViewNotificationsRegister: No view notifications registered for the domain ${domain}`));
    }
    return viewNotifications?.viewFilterFunction || null;
  }

  public getAll(): ViewNotifications[] {
    return Object.values(this.registry);
  }

  public static getInstance(): ViewNotificationsRegister {
    if (!ViewNotificationsRegister.instance) {
      ViewNotificationsRegister.instance = new ViewNotificationsRegister();
    }
    return ViewNotificationsRegister.instance;
  }

  public static reset() {
    ViewNotificationsRegister.instance = undefined;
  }
}

export { ViewNotificationsRegister };
